import { IsArray, IsNumber } from 'class-validator';

export class GetStocksForRebatesDto {
  @IsNumber()
  merchantGroupId: number;

  @IsNumber()
  supplierId: number;

  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryLev1Ids?: number[];


}